import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import MealsStructure from "../diet/meal/MealsStructure";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchClosureReportData,
  fetchClosureReportListData,
} from "../../redux/reducers/apiSlice";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import useGymsData from "../../hooks/useGymsData";
import SelectDropdownLabel from "../components-react/SelectDropdownLabel";
import { closureTbColumns } from "./leadClosureUtils";
import { convertThenFormat } from "../common-data/Converts";
import {
  CompletedIcon,
  ExpectedIcon,
  PendingIcon,
} from "../../images/icons/icons";
import moment from "moment";

const LeadClosure = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const {
    data: gymsData,
    isLoading: isLoadingGyms,
    isFetching: isFetchingGyms,
  } = useGymsData();

  const { closureReport, closureReportList } = useSelector(
    (state) => state.api
  );

  const isAdmin = userInfoData?.account_type === "admin";

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const [selectedGym, setSelectedGym] = useState(
    !isAdmin
      ? {
          label: userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : null
  );

  const initialFilter = {
    filter_type: "",
    gym_id: "",
    followup_date: moment().format("YYYY-MM-DD"),
    limit: pageLimit,
    page: isPage + 1,
  };

  const [filters, setFilters] = useState(initialFilter);
  const payload = {
    filters: filters,
    token: userInfoData?.token,
  };

  useEffect(() => {
    dispatch(fetchClosureReportData(payload));
    dispatch(fetchClosureReportListData(payload));
  }, [userInfoData, filters, isPage, pageLimit, dispatch]);

  const handleReset = () => {
    setFilters(initialFilter);
    setSelectedGym(null);
  };

  const handleClickCard = (filterType) => {
    setFilters({
      ...filters,
      filter_type: filterType,
    });
  };

  useEffect(() => {
    setSelectedGym(
      !isAdmin
        ? {
            label: userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : null
    );
  }, [userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      gym_id: selectedGym ? selectedGym?.value : "",
      limit: pageLimit,
    }));
  }, [selectedGym, pageLimit, isPage]);

  useEffect(() => {
    setFilters({
      ...filters,
      page: isPage + 1,
    });
  }, [isPage]);

  const handleChangeDate = (e) => {
    const { value } = e.target;

    setFilters((prevs) => ({
      ...prevs,
      followup_date: value,
    }));
  };

  return (
    <div className="leadClosure">
      <Row>
        <Col>
          <MealsStructure text={"Lead Closure Report"} />
        </Col>
      </Row>
      <br />

      <div className="cmnFilterStructureContainer ptTrackContainer">
        <div className="filterblock gridSpanTwo">
          <div className="filterHeadingNBtn">
            <h5 className="filterHeading">All Filters</h5>
            <Button variant="outline-danger" onClick={handleReset}>
              Reset Filter
            </Button>
          </div>

          <div className="filterblock grid__two">
            {isAdmin && (
              <div className={`commonWrapper dropdownCommonWrapper `}>
                <SelectDropdownLabel
                  options={gymsData?.length > 0 ? gymsData : []}
                  value={selectedGym}
                  setSelectedOption={(selectedOption) =>
                    setSelectedGym(selectedOption)
                  }
                  name="Select Gym"
                />
              </div>
            )}
            <div
              className={`closure-date-picker commonWrapper commonWrapper dropdownCommonWrapper `}
            >
              <input
                type="date"
                className={`${filters.followup_date ? "date-has-value" : ""}`}
                value={filters.followup_date}
                onChange={handleChangeDate}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="leadClosure__Cards">
        <div className="leadClosure__Card">
          <h3>Overall</h3>
          <hr />

          <p
            className={`leadClosureCard__text ${
              filters.filter_type === "closure_expected_today"
                ? "activeClass"
                : ""
            }`}
            onClick={() => handleClickCard("closure_expected_today")}
          >
            <span className="leadClosureCard__title">
              <ExpectedIcon />
              Closure Expected{" "}
            </span>
            <span className="leadClosure__Price">
              {`₹${convertThenFormat(
                closureReport?.data?.closure_expected_today_val || 0
              )}`}
              ({closureReport?.data?.closure_expected_today})
            </span>
          </p>
          <div className="leadClosureCard__texts">
            <p
              className={`leadClosureCard__text ${
                filters.filter_type === "closure_done_today"
                  ? "activeClass"
                  : ""
              }`}
              onClick={() => handleClickCard("closure_done_today")}
            >
              <span className="leadClosureCard__title">
                <CompletedIcon />
                <span>Done</span>
              </span>
              <span className="leadClosure__Price">
                {` ₹${convertThenFormat(
                  closureReport?.data?.closure_done_today_val || 0
                )}`}
                ({closureReport?.data?.closure_done_today})
              </span>
            </p>
            <p
              className={`leadClosureCard__text ${
                filters.filter_type === "closure_pending_today"
                  ? "activeClass"
                  : ""
              }`}
              onClick={() => handleClickCard("closure_pending_today")}
            >
              <span className="leadClosureCard__title">
                <PendingIcon />
                <span>Pending</span>
              </span>
              <span className="leadClosure__Price">
                {` ₹${convertThenFormat(
                  closureReport?.data?.closure_pending_today_val || 0
                )}`}
                ({closureReport?.data?.closure_pending_today})
              </span>
            </p>
          </div>
        </div>

        <div className="leadClosure__Card">
          <h3>Fresh</h3>
          <hr />
          <p
            className={`leadClosureCard__text ${
              filters.filter_type === "fresh_closure_expected_today"
                ? "activeClass"
                : ""
            }`}
            onClick={() => handleClickCard("fresh_closure_expected_today")}
          >
            <span className="leadClosureCard__title">
              <ExpectedIcon />
              <span>Closure Expected </span>
            </span>

            <span className="leadClosure__Price">
              {`₹${convertThenFormat(
                closureReport?.data?.fresh_closure_expected_today_val || 0
              )}`}
              ({closureReport?.data?.fresh_closure_expected_today})
            </span>
          </p>
          <div className="leadClosureCard__texts">
            <p
              className={`leadClosureCard__text ${
                filters.filter_type === "fresh_closure_done_today"
                  ? "activeClass"
                  : ""
              }`}
              onClick={() => handleClickCard("fresh_closure_done_today")}
            >
              <span className="leadClosureCard__title">
                <CompletedIcon />
                <span>Done</span>
              </span>
              <span className="leadClosure__Price">
                {`₹${convertThenFormat(
                  closureReport?.data?.fresh_closure_done_today_val || 0
                )}`}
                ({closureReport?.data?.fresh_closure_done_today})
              </span>
            </p>
            <p
              className={`leadClosureCard__text ${
                filters.filter_type === "fresh_closure_pending_today"
                  ? "activeClass"
                  : ""
              }`}
              onClick={() => handleClickCard("fresh_closure_pending_today")}
            >
              <span className="leadClosureCard__title">
                <PendingIcon />
                <span>Pending</span>
              </span>
              <span className="leadClosure__Price">
                {`₹${convertThenFormat(
                  closureReport?.data?.fresh_closure_pending_today_val || 0
                )}`}
                ({closureReport?.data?.fresh_closure_pending_today})
              </span>
            </p>
          </div>
        </div>

        <div className="leadClosure__Card">
          <h3>Past</h3>
          <hr />
          <p
            className={`leadClosureCard__text ${
              filters.filter_type === "past_closure_expected_today"
                ? "activeClass"
                : ""
            }`}
            onClick={() => handleClickCard("past_closure_expected_today")}
          >
            <span className="leadClosureCard__title">
              <ExpectedIcon />
              <span>Closure Expected </span>
            </span>
            <span className="leadClosure__Price">
              {`₹${convertThenFormat(
                closureReport?.data?.past_closure_expected_today_val || 0
              )}`}
              ({closureReport?.data?.past_closure_expected_today})
            </span>
          </p>
          <div className="leadClosureCard__texts">
            <p
              className={`leadClosureCard__text ${
                filters.filter_type === "past_closure_done_today"
                  ? "activeClass"
                  : ""
              }`}
              onClick={() => handleClickCard("past_closure_done_today")}
            >
              <span className="leadClosureCard__title">
                <CompletedIcon />
                <span>Done</span>
              </span>

              <span className="leadClosure__Price">
                {`₹${convertThenFormat(
                  closureReport?.data?.past_closure_done_today_val || 0
                )}`}
                ({closureReport?.data?.past_closure_done_today})
              </span>
            </p>
            <p
              className={`leadClosureCard__text ${
                filters.filter_type === "past_closure_pending_today"
                  ? "activeClass"
                  : ""
              }`}
              onClick={() => handleClickCard("past_closure_pending_today")}
            >
              <span className="leadClosureCard__title">
                <PendingIcon />
                <span>Pending</span>
              </span>

              <span className="leadClosure__Price">
                {`₹${convertThenFormat(
                  closureReport?.data?.past_closure_pending_today_val || 0
                )}`}
                ({closureReport?.data?.past_closure_pending_today})
              </span>
            </p>
          </div>
        </div>

        <div className="leadClosure__Card">
          <h3>Moved Closures</h3>
          <hr />
          <p
            className={`leadClosureCard__text ${
              filters.filter_type === "closure_expected_today_moved"
                ? "activeClass"
                : ""
            }`}
            onClick={() => handleClickCard("closure_expected_today_moved")}
          >
            <span className="leadClosureCard__title">
              <ExpectedIcon />
              <span>Closure Expected</span>
            </span>

            <span className="leadClosure__Price">
              {`₹${convertThenFormat(
                closureReport?.data?.closure_expected_today_moved_val || 0
              )}`}
              ({closureReport?.data?.closure_expected_today_moved})
            </span>
          </p>
        </div>
      </div>
      <br />
      <div>
        <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table">
          {isLoadingGyms ? (
            <ReactVortoxSpinner />
          ) : (
            <PaymentLinkTable
              tableColumns={closureTbColumns}
              tableData={closureReportList?.data}
              tablePagination={closureReportList?.pagination}
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              setPageLimit={setPageLimit}
              pageLimit={pageLimit}
              isFirstColSticky={true}
            />
          )}
        </div>

        {/* <div className="lead-logs-card-container only-mobile">
          {loading ? (
            <ReactVortoxSpinner />
          ) : (
            <AgreementReportMobile
              tableData={agreementReport?.data}
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              tablePagination={agreementReport?.pagination}
              setPageLimit={setPageLimit}
              pageLimit={pageLimit}
              showPassword={showPassword}
              handleEyeOtp={handleEyeOtp}
            />
          )}
        </div> */}
      </div>
    </div>
  );
};

export default LeadClosure;
